"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeVersion = void 0;
var TradeVersion;
(function (TradeVersion) {
    TradeVersion["LEGACY"] = "LEGACY";
    TradeVersion["AGGREGATOR"] = "AGGREGATOR";
})(TradeVersion || (exports.TradeVersion = TradeVersion = {}));
